// https://en.wikipedia.org/wiki/YIQ#From_RGB_to_YIQ
export const getIntensity = (hexColour: string) => {
	const r = parseInt(hexColour.substring(1, 3), 16);
	const g = parseInt(hexColour.substring(3, 5), 16);
	const b = parseInt(hexColour.substring(5, 7), 16);
	return (r * 299 + g * 587 + b * 114) / 1000;
};

export const getStatusBarColour = (hexColour: string) =>
	getIntensity(hexColour) >= 128
		? "#6D7274" // GREY_550
		: "#FFFFFF";

export const getLogoColour = (hexColour: string) => {
	return getIntensity(hexColour) >= 128
		? "#212322" // BLACK_900
		: "#FFFFFF";
};
